export interface Relatorio {
  id_relatorio: number;
  id_chamado?: string; // Pode ser opcional caso não seja informado
  nome_arquivo: string;
  caminho_arquivo: string;
  tamanho: string;
  enviador: string;
  tipo_arquivo: string;
  data_upload: Date;
}

export type MovimentacaoEstoque = {
  id: number;
  produtoId: number;
  tipoMovimentacao: string;
  quantidade: number;
  quantidadeAnterior: number;
  quantidadePosterior: number;
  usuarioResponsavel: string;
  dataHoraMovimentacao: string; // Vem como string do JSON
  observacao?: string;
};

export interface Chamado {
  descricao: string;
  email: string;
  empresa: string;
  num_Chamado: string;
  horariO_CRIADO: Date;
  horariO_RESPONDIDO: Date; // Esta propriedade parece não ser usada no backend, considere remover se não for necessária.
  relatorios: Relatorio[];
  telefone: string;
  tipoSolicitacao: string;
  status: string;
  respostas: RespostaChamado[]; // << CORRIGIDO: de string[] para RespostaChamado[]
  uuid: string;
}

export interface RespostaChamado {
  id: number; // Corresponde ao ID da resposta
  textO_RESPOSTA: string;
  datA_RESPOSTA: Date;
  nomE_USUARIO_RESPOSTA: string;
  id_USUARIO_RESPOSTA: number;
}

export type Produto = {
  id: number;
  ultimoUsuario: string;
  nome: string;
  especificacoes: string;
  quantidade: number;
  quantidadeMinima: number;
  quantidadeMaxima: number;
  projeto: string;
  serveParaRaioX: string;
  imagemUrl: string;
  localizacao: string;
  fornecedor: string;
  observacao: string;
};

export type Usuario = {
  id: number;
  nome: string;
  login: string;
  senha: string;
  ultimaSenha?: string | null;
  email: string;
  cpf: string | null;
  sessionExpire?: string | null;
  nivel: string;
  dataCadastro: string; // formato ISO 8601
  dataAlteracao: string;
  dataExclusao: string;
  chave: string | null;
  ativacao: number;
  reset: string;
  ativo: number;
};

export interface ChamadoFormData {
  empresa: string;
  descricao: string;
  num_chamado: string;
  tipo_solicitacao: string;
  telefone: string;
}
export interface SolicitacaoCompra {
  id: number;
  nomeProduto: string;
  especificacoes: string;
  quantidadeSolicitada: number;
  fornecedor: string;
  projeto: string;
  localizacao: string;
  justificativa: string;
  status: "PENDENTE" | "APROVADO" | "REJEITADO";
  solicitanteUsuario: string;
  dataSolicitacao: string;
  aprovadorUsuario: string | null;
  dataAprovacao: string | null;
  produtoVinculadoId: number | null;
  observacaoAprovacao: string | null;
}


export const TIPOS_SOLICITACAO = [
  "Prioridade Alta - Periférico Danificado",
  "Prioridade Alta - Sistema com erro ou indisponível",
  "Prioridade Alta - Integração WMS Recintos",
  "Prioridade Média - Dúvidas/Suporte",
  "Prioridade Baixa - Melhorias",
] as const;
